/** The header's palette trigger (1.I-2 deliverable 20): "Search" with its shortcut. */
import { Icon, Kbd } from '@codex/ui';

export function PaletteTrigger({
  apple,
  open,
  onOpen,
}: {
  readonly apple: boolean;
  readonly open: boolean;
  readonly onOpen: () => void;
}) {
  const shortcut = apple ? '⌘K' : 'Ctrl K';
  return (
    <button
      type="button"
      className="cx-button cx-button--ghost cx-button--sm cx-nav-trigger"
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-label={`Search and commands (${apple ? '⌘K' : 'Ctrl+K'})`}
      data-testid="nav.palette.trigger"
      onClick={onOpen}
    >
      <Icon name="search" />
      <span className="cx-button__label">Search</span>
      <Kbd>{shortcut}</Kbd>
    </button>
  );
}
